import cn from 'classnames';
import React, {FC} from 'react';

import {IFieldMeta, IWidgetsLayout} from 'entities/metadata';

import {WidgetLayoutItem} from './widget-layout-item/widget-layout-item';

interface IWidgetLayoutRowProps {
    widgetLayout?: Array<IWidgetsLayout>;
    fields?: IFieldMeta[];
    data?: any;
    entityName: string;
}

export const WidgetLayoutRow: FC<IWidgetLayoutRowProps> = ({
    widgetLayout, fields, data, entityName,
}: IWidgetLayoutRowProps) => (
    <div className={cn('main-widget-page__widget-row')}>
        {widgetLayout?.map(widget => (
            <WidgetLayoutItem
                widget={widget}
                field={fields?.filter(field => field.key === widget.statisticsFieldKey)[0]}
                data={data}
                entityName={entityName}
            />
        ))}
    </div>
);
